export default __webpack_public_path__ + "static/media/ketogo-logo@2x.61a6b819.png";